import { all, fork } from 'redux-saga/effects'

import AnalyticsSaga from './AnalyticsSaga'

export default function* analyticsSagas() {
  yield all([fork(new AnalyticsSaga().supervise)])
}
